import { FC, useId } from 'react'
import cx from 'classnames'

import { Icons } from '../Icon'
import FormikField from '../../form/FormikField'
import { FormikFormProps } from '../../form/FormikForm'
import { FilterCheckProps } from '../../form/FilterCheck'
import { colors } from '../../theme'

import * as SC from './styled'

export type SearchAndFilterFormProps = SearchFormProps & {
  filters?: string[]
}

export type SearchAndFilterProps = {
  className?: string
  formikFormProps?: FormikFormProps<SearchAndFilterFormProps>
  filters?: FilterCheckProps[]
  texts: {
    placeholder?: string
    submitLabel?: string
    resetLabel?: string
    legend?: string
  }
}

const SearchAndFilter: FC<SearchAndFilterProps> = ({
  className,
  formikFormProps,
  filters,
  texts,
}) => {
  const id = useId()

  return formikFormProps ? (
    <SC.Container className={cx('SearchAndFilter', className)}>
      <SC._FormikForm
        {...formikFormProps}
        onContextUpdate={formikFormProps?.onContextUpdate}
        onSubmit={formikFormProps?.onSubmit}
      >
        {({ setFieldValue, submitForm }) => (
          <>
            <SC.Search>
              <FormikField
                Component={SC.Input}
                id={`${id}-input`}
                name="term"
                type="search"
                placeholder={texts.placeholder}
              />
              {texts.placeholder && (
                <SC.Placeholder htmlFor={`${id}-input`}>
                  {texts.placeholder}
                </SC.Placeholder>
              )}
              <SC.Reset
                type="button"
                aria-label={texts.resetLabel}
                onClick={() => {
                  setFieldValue('term', '')
                  submitForm()
                }}
              >
                <SC.ResetIcon
                  icon={Icons.closeSmall}
                  color={colors.black}
                  aria-hidden
                />
              </SC.Reset>
              <SC.Submit type="submit" aria-label={texts.submitLabel}>
                <SC.SubmitIcon icon={Icons.search} aria-hidden />
              </SC.Submit>
            </SC.Search>
            {filters && (
              <SC.Filters>
                <SC.FiltersLegend>{texts.legend}</SC.FiltersLegend>
                <SC.FiltersContent>
                  {filters?.map((filter, index) => (
                    <FormikField
                      type="checkbox"
                      key={index}
                      Component={SC._FilterCheck}
                      id={`${id}-filter--${index}`}
                      name="filters"
                      {...filter}
                    />
                  ))}
                </SC.FiltersContent>
              </SC.Filters>
            )}
          </>
        )}
      </SC._FormikForm>
    </SC.Container>
  ) : null
}

export default SearchAndFilter
